import React, {useState, useLayoutEffect, useEffect} from "react";
import axios from "axios";
import {Link} from "react-router-dom";
import imgDay from "../../../assets/images/icons/unicons/sunny.png";
import imgEvening from "../../../assets/images/icons/unicons/full-moon.png";
import imgNight from "../../../assets/images/icons/unicons/moon-and-stars.png";
import imgMorning from "../../../assets/images/icons/unicons/stars.png";
import {Button} from "primereact/button";

export default function DateFunction(props) {
	const locale = "en";
	const [today, setDate] = useState(new Date());
	const [weather, setWeather] = useState(null);
	useEffect(() => {
		const timer = setInterval(() => {
			setDate(new Date());
		}, 1000);
		return () => {
			clearInterval(timer);
		};
	}, []);
	useEffect(() => {
		if (navigator.geolocation) {
			navigator.geolocation.getCurrentPosition(async position => {
				const {latitude, longitude} = position.coords;
				try {
					const res = await axios.get(
						`https://api.open-meteo.com/v1/forecast?latitude=${latitude}&longitude=${longitude}&current_weather=true`,
					);
					setWeather(res.data.current_weather);
				} catch (error) {
					console.error("Failed to fetch weather data", error);
				}
			});
		}
	}, []);
	const time = today.toLocaleTimeString(locale, {hour: "numeric", hour12: true, minute: "numeric"});
	const monthString = [
		"հունվար",
		"փետրվար",
		"մարտ",
		"ապրիլ",
		"մայիս",
		"հունիս",
		"հուլիս",
		"օգոստոս",
		"սեպտեմբեր",
		"հոկտեմբեր",
		"նոյեմբեր",
		"դեկտեմբեր",
	];
	const weekString = ["կիր", "երկ", "երք", "չրք", "հնգ", "ուրբ", "շբթ"];
	const date =
		today.getDate() +
		" " +
		monthString[today.getMonth()] +
		" " +
		today.getFullYear() +
		", " +
		weekString[today.getDay()];

	const [dayInterval, setDayInterval] = useState({
		morning: false,
		day: false,
		evening: false,
		night: false,
	});
	useLayoutEffect(() => {
		if (5 <= today.getHours() && today.getHours() < 8) {
			setDayInterval({...dayInterval, morning: true});
		}
		if (8 <= today.getHours() && today.getHours() < 17) {
			setDayInterval({...dayInterval, day: true});
		}
		if (17 <= today.getHours() && today.getHours() < 21) {
			setDayInterval({...dayInterval, evening: true});
		}
		if (21 <= today.getHours() && today.getHours() > 0) {
			setDayInterval({...dayInterval, night: true});
		}
		if (0 <= today.getHours() && today.getHours() < 5) {
			setDayInterval({...dayInterval, night: true});
		}
	}, []);
	return (
		<div className="card w-100 b-radius b-shadow border-0 p-3 py-4 my-2">
			<div className="row ">
				<div className="col-lg-3 col-md-3 col-12 text-center mx-auto order-lg-2 order-1">
					{dayInterval.morning ? <img src={imgMorning} height="150" alt=" " /> : null}
					{dayInterval.day ? <img src={imgDay} height="150" alt=" " /> : null}
					{dayInterval.evening ? <img src={imgEvening} height="150" alt=" " /> : null}
					{dayInterval.night ? <img src={imgNight} height="150" alt=" " /> : null}
				</div>
				<div className="col-lg-9 col-md-9 overflow-hidden col-12 text-lg-start text-md-end text-center order-lg-1 order-2">
					<div className="card-body px-5 pb-0">
						<div className="fs-3 m-0 fw-bold text-uppercase text-nowrap text-primary">
							{dayInterval.morning ? "Բարի լույս " : null}
							{dayInterval.day ? "Բարի օր " : null}
							{dayInterval.evening ? "Բարի երեկո " : null}
							{dayInterval.night ? "Արդեն գիշեր է " : null}
							<span className="text-truncate">
								{props?.profile?.profile?.partner?.full_name_am}
							</span>
						</div>
						<div className="d-block small">
							Այսօր՝ {date}, {time}
							{weather && (
								<div className="mb-4">
									Եղանակը այժմ՝ {weather.temperature}°C,{" "}
									{weather.weathercode < 3
										? "արևոտ"
										: weather.weathercode < 45
										? "մառախուղոտ"
										: "ամպամած"}
								</div>
							)}
						</div>
						<Link to={`/accounts/${props?.profile?.id}`}>
							<Button
								label="Անցնել անձնական էջ"
								icon="pi pi-arrow-right"
								rounded
								severity="warning"
							/>
						</Link>
					</div>
				</div>
			</div>
		</div>
	);
}
